(function(){
  /* Carousel */
  var track=document.getElementById('jvCarouselTrack');
  var thumbs=document.querySelectorAll('#jv-lander .jv-carousel-thumb');
  var cur=0,cnt=track.children.length;

  function goTo(i){
    cur=i;
    track.children[i].scrollIntoView({behavior:'smooth',block:'nearest',inline:'start'});
    thumbs.forEach(function(t,x){t.classList.toggle('jv-active',x===i)});
  }
  thumbs.forEach(function(t){t.addEventListener('click',function(){goTo(+this.dataset.slide)})});

  var st;
  track.addEventListener('scroll',function(){
    clearTimeout(st);
    st=setTimeout(function(){
      var i=Math.round(track.scrollLeft/track.offsetWidth);
      if(i!==cur&&i>=0&&i<cnt){
        cur=i;
        thumbs.forEach(function(t,x){t.classList.toggle('jv-active',x===i)});
      }
    },80);
  },{passive:true});

  /* Tiers */
  var tiers={
    1:{price:'$49.99',strike:'',cta:'Add to Cart \u2014 $49.99',freq:'1 month',qty:1,plan:2655420494},
    2:{price:'$69.98',strike:'$99.98',cta:'Add to Cart \u2014 Save 30%',freq:'2 months',qty:2,plan:2655453262},
    3:{price:'$74.99',strike:'$149.97',cta:'Add to Cart \u2014 Save 50%',freq:'3 months',qty:3,plan:2655486030}
  };
  var sel=3;
  var variantId=43533787103310;
  var discountCode='LTO-CREATINESTICK';

  function selectTier(n){
    sel=n;
    document.querySelectorAll('#jv-lander .jv-tier-card').forEach(function(c){c.classList.toggle('jv-selected',+c.dataset.tier===n)});
    var t=tiers[n];
    document.getElementById('jvCtaTopText').textContent=t.cta;
    document.getElementById('jvCtaBottomText').textContent=t.cta;
    document.getElementById('jvStickyPrice').textContent=t.price;
    document.getElementById('jvSubFreq').textContent=t.freq;
    document.getElementById('jvSubFreqBottom').textContent=t.freq;
    var s=document.getElementById('jvStickyStrike');
    if(t.strike){s.textContent=t.strike;s.style.display=''}else{s.style.display='none'}
  }
  document.querySelectorAll('#jv-lander .jv-tier-card').forEach(function(c){c.addEventListener('click',function(){selectTier(+this.dataset.tier)})});

  /* Loading messages for ATC */
  var loadingSteps=[
    'Checking availability',
    'Reserving your order',
    'Applying discount',
    'Redirecting to checkout'
  ];

  function animateDots(el,msg,cb){
    var dots=0;
    var iv=setInterval(function(){
      dots=(dots%3)+1;
      el.textContent=msg+Array(dots+1).join('.');
    },400);
    if(cb) cb(iv);
    return iv;
  }

  function runLoadingSequence(btns,onDone){
    var stepIndex=0;
    var currentInterval=null;
    var spans=[];
    btns.forEach(function(b){
      var sp=b.querySelector('span');
      if(sp) spans.push(sp);
    });

    function showStep(){
      if(stepIndex>=loadingSteps.length){
        if(currentInterval) clearInterval(currentInterval);
        if(onDone) onDone();
        return;
      }
      var msg=loadingSteps[stepIndex];
      if(currentInterval) clearInterval(currentInterval);
      var dots=0;
      currentInterval=setInterval(function(){
        dots=(dots%3)+1;
        var txt=msg+Array(dots+1).join('.');
        spans.forEach(function(sp){sp.textContent=txt});
      },400);
      // Show message immediately
      spans.forEach(function(sp){sp.textContent=msg+'.'});
    }

    showStep();
    return {
      next:function(){
        stepIndex++;
        showStep();
      },
      finish:function(){
        if(currentInterval) clearInterval(currentInterval);
      }
    };
  }

  /* ATC - clear cart, add with selling plan, redirect to checkout */
  window.jvHandleAddToCart=function(){
    var t=tiers[sel];
    var btns=document.querySelectorAll('#jv-lander .jv-btn-cta');
    btns.forEach(function(b){b.style.opacity='.85';b.style.pointerEvents='none'});

    var seq=runLoadingSequence(btns);

    // Step 1: Checking availability → clear cart
    fetch('/cart/clear.js',{method:'POST',headers:{'Content-Type':'application/json'}})
    .then(function(){
      // Step 2: Reserving your order → add to cart
      seq.next();
      return fetch('/cart/add.js',{
        method:'POST',
        headers:{'Content-Type':'application/json'},
        body:JSON.stringify({items:[{id:variantId,quantity:t.qty,selling_plan:t.plan}]})
      });
    })
    .then(function(r){if(!r.ok)throw new Error('Cart error');return r.json()})
    .then(function(){
      // Step 3: Applying discount
      seq.next();
      return new Promise(function(resolve){setTimeout(resolve,800)});
    })
    .then(function(){
      // Step 4: Redirecting to checkout
      seq.next();
      return new Promise(function(resolve){setTimeout(resolve,600)});
    })
    .then(function(){
      seq.finish();
      window.location.href='/discount/'+discountCode+'?redirect=/checkout';
    })
    .catch(function(e){
      console.error(e);
      seq.finish();
      var orig=tiers[sel].cta;
      btns.forEach(function(b){
        b.style.opacity='';b.style.pointerEvents='';
        var sp=b.querySelector('span');
        if(sp) sp.textContent=orig;
      });
    });
  };

  /* Sticky */
  var bar=document.getElementById('jvStickyBar'),info=document.querySelector('#jv-lander .jv-product-info');
  function onScroll(){bar.classList.toggle('jv-visible',info.getBoundingClientRect().bottom<0)}
  window.addEventListener('scroll',onScroll,{passive:true});onScroll();

  /* Detail panels accordion (product info dropdowns) */
  document.querySelectorAll('#jv-lander .jv-detail-q').forEach(function(q){
    q.addEventListener('click',function(){
      var item=this.parentElement;
      var wasOpen=item.classList.contains('jv-open');
      document.querySelectorAll('#jv-lander .jv-detail-item.jv-open').forEach(function(i){i.classList.remove('jv-open')});
      if(!wasOpen) item.classList.add('jv-open');
    });
  });

  /* FAQ accordion */
  document.querySelectorAll('#jv-lander .jv-faq-q').forEach(function(q){
    q.addEventListener('click',function(){
      var item=this.parentElement;
      var wasOpen=item.classList.contains('jv-open');
      document.querySelectorAll('#jv-lander .jv-faq-item.jv-open').forEach(function(i){i.classList.remove('jv-open')});
      if(!wasOpen) item.classList.add('jv-open');
    });
  });

  /* Lucide */
  if(window.lucide){lucide.createIcons();}
})();
